declare module 'pixi.js' {
  interface Loader {
    /**
     * List for session resources
     */

    sessionResourceNames: string[];
    /**
     * Add resources for loading
     * @param name resource name
     * @param param2 resource url or loading options
     * @param param3 loading options or callback
     * @param param4 callback
     */
    add(name: string, param2?: string | ILoaderOptions, param3?: ILoaderOptions | Function, param4?: Function): this;

    /**
     * Start loading
     */
    loadAsync(): Promise<void>;
  }
}

import { ILoaderOptions, Loader } from 'pixi.js';

Loader.prototype.sessionResourceNames = [];

const add = Loader.prototype.add;
Loader.prototype.add = function (
  name: string,
  param2?: string | ILoaderOptions,
  param3?: ILoaderOptions | Function,
  param4?: Function
): Loader {
  if (this.resources[name]) return this;
  const url = typeof param2 === 'string' ? param2 : name;
  const options = typeof param2 === 'object' ? param2 : typeof param3 === 'object' ? param3 : undefined;
  const cb = typeof param3 === 'function' ? param3 : param4;
  if (url === '') {
    throw new Error("Loader can't add empty url.");
  }
  if (
    options !== undefined &&
    options.cacheSession !== undefined &&
    options.cacheSession &&
    !this.sessionResourceNames.includes(name)
  ) {
    this.sessionResourceNames.push(name);
  }
  return add.call(this, name, url, options, cb);
};

Loader.prototype.loadAsync = async function (): Promise<void> {
  return new Promise((resolve, reject) => {
    this.load((_, resources) => {
      for (const name in resources) {
        const resource = resources[name];
        if (resource && resource.error) {
          reject(resource.error);
          return;
        }
      }
      resolve();
    });
  });
};
